/* Theme ArtWeb v1.0.0 · © Studio Art Web · https://studioartweb.com.br · não editar sem falar com o Studio */
/*
 * Harmony Health | hh-cab-menu.js
 * Painel de produtos do item "Produtos" no menu do computador (markup em
 * snippets/hh-cab-produtos.liquid, estilos em assets/hh-cabecalho.css, bloco r6).
 * - Liga o painel ao link do menu cujo href é igual ao data-hh-cab-alvo.
 * - Abre ao passar o mouse ou ao focar o link; fecha ao sair (com pequena folga),
 *   com Esc (o foco volta ao link) ou quando o foco sai do link e do painel.
 * - Teclado: Tab no link aberto entra no painel; Tab no último item segue para o
 *   próximo item do menu; Shift+Tab no primeiro item volta ao link.
 * - Só age no layout de menu (data-menu-style="menu"); na gaveta do celular não faz nada.
 */

function iniciar() {
  const cabecalho = document.getElementById('header-component');
  const painel = document.getElementById('hh-cab-painel-produtos');
  if (!cabecalho || !painel || painel.dataset.hhPronto) return;
  const alvo = painel.dataset.hhCabAlvo;
  const link = [...cabecalho.querySelectorAll('.menu-list__link[href]')].find(
    (a) => a.getAttribute('href') === alvo && !a.closest('[slot="overflow"]')
  );
  if (!link) return;
  painel.dataset.hhPronto = '1';

  const item = link.closest('.menu-list__list-item') || link;
  link.classList.add('hh-cab-tem-painel');
  link.setAttribute('aria-haspopup', 'true');
  link.setAttribute('aria-expanded', 'false');
  link.setAttribute('aria-controls', painel.id);

  let timer = null;
  let aberto = false;
  let suprimir = false;

  // o header-menu.js do Horizon também mexe no aria-expanded do item ativo; aqui ele
  // sempre volta a refletir o estado real do painel
  new MutationObserver(() => {
    const certo = String(aberto);
    if (link.getAttribute('aria-expanded') !== certo) link.setAttribute('aria-expanded', certo);
  }).observe(link, { attributes: true, attributeFilter: ['aria-expanded'] });

  const ativo = () => cabecalho.dataset.menuStyle !== 'drawer';
  const focaveis = () => [...painel.querySelectorAll('a[href]')];

  function abrir() {
    clearTimeout(timer);
    if (aberto || !ativo()) return;
    aberto = true;
    painel.hidden = false;
    link.setAttribute('aria-expanded', 'true');
    cabecalho.classList.add('hh-cab-painel-aberto');
    requestAnimationFrame(() => painel.classList.add('is-aberto'));
  }

  function fechar(imediato = false) {
    clearTimeout(timer);
    if (!aberto) return;
    aberto = false;
    link.setAttribute('aria-expanded', 'false');
    cabecalho.classList.remove('hh-cab-painel-aberto');
    painel.classList.remove('is-aberto');
    const some = () => {
      if (!aberto) painel.hidden = true;
    };
    if (imediato || matchMedia('(prefers-reduced-motion: reduce)').matches) some();
    else setTimeout(some, 200);
  }

  const agendaFechar = () => {
    clearTimeout(timer);
    timer = setTimeout(() => fechar(), 520);
  };

  for (const el of [item, painel]) {
    // qualquer movimento dentro do item ou do painel cancela o fechamento agendado
    el.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'touch' && aberto) clearTimeout(timer);
    });
    el.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'touch') abrir();
    });
    el.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'touch') agendaFechar();
    });
  }

  // clique no item também abre (e fecha se já estiver aberto); evita depender só do hover
  link.addEventListener('click', (e) => {
    if (!ativo()) return;
    if (!aberto) { e.preventDefault(); abrir(); }
  });

  link.addEventListener('focus', () => {
    if (suprimir) suprimir = false;
    else abrir();
  });

  link.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      fechar(true);
      return;
    }
    if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey && aberto)) {
      const primeiro = focaveis()[0];
      if (!primeiro) return;
      e.preventDefault();
      abrir();
      requestAnimationFrame(() => primeiro.focus());
    }
  });

  painel.addEventListener('keydown', (e) => {
    const lista = focaveis();
    const i = lista.indexOf(document.activeElement);
    if (e.key === 'Escape') {
      e.preventDefault();
      fechar(true);
      // o foco no link reabriria o painel; fica fechado até o próximo foco
      suprimir = true;
      link.focus({ preventScroll: true });
    } else if (e.key === 'Tab' && e.shiftKey && i === 0) {
      e.preventDefault();
      suprimir = true;
      link.focus({ preventScroll: true });
    } else if (e.key === 'Tab' && !e.shiftKey && i === lista.length - 1) {
      const links = [...cabecalho.querySelectorAll('.menu-list__link')].filter(
        (a) => a.offsetParent !== null
      );
      const proximo = links[links.indexOf(link) + 1];
      if (proximo) {
        e.preventDefault();
        fechar(true);
        proximo.focus();
      }
    }
  });

  const dentro = (el) => el && (painel.contains(el) || item.contains(el));
  item.addEventListener('focusout', (e) => {
    if (!dentro(e.relatedTarget)) agendaFechar();
  });
  painel.addEventListener('focusout', (e) => {
    if (!dentro(e.relatedTarget)) agendaFechar();
  });

  document.addEventListener('pointerdown', (e) => {
    if (aberto && !dentro(e.target)) fechar(true);
  });
  window.addEventListener('scroll', () => aberto && !painel.matches(':hover') && fechar(), { passive: true });
}

// o menu do Horizon é hidratado depois do primeiro quadro; tenta de novo quando ele aparece
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
else iniciar();
customElements.whenDefined('header-menu').then(iniciar);
window.addEventListener('load', iniciar);
document.addEventListener('shopify:section:load', () => requestAnimationFrame(iniciar));
